import React from 'react'
import { useTranslation } from 'react-i18next'

import { Progress } from '@/components/ui/progress'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

import { Skeleton } from '../ui/skeleton'

export const LoadingReport = ({
  progress,
  title,
  description,
  progressText,
}: {
  progress: number
  title?: string
  description?: string
  progressText?: string
}) => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center justify-center h-full w-full ">
      <div className="w-full h-full absolute z-0 flex items-center justify-center">
        <div className="w-5/12 flex flex-col gap-8 opacity-30 max-md:w-10/12">
          <div className="flex justify-between max-md:gap-2">
            <Skeleton className="h-24 w-24 rounded-full" />
            <Skeleton className="h-24 w-5/6" />
          </div>
          <div className="flex gap-3">
            <Skeleton className="h-14 w-full" />
            <Skeleton className="h-14 w-full" />
            <Skeleton className="h-14 w-full" />
          </div>
          <div className="w-full">
            <Skeleton className="h-48 w-full" />
          </div>
          <div className="flex gap-3">
            <Skeleton className="h-24 w-full" />
            <Skeleton className="h-24 w-full" />
            <Skeleton className="h-24 w-full" />
          </div>
          <div className="w-full">
            <Skeleton className="h-48 w-full" />
          </div>
          <div className="flex gap-3">
            <Skeleton className="h-24 w-full" />
            <Skeleton className="h-24 w-full" />
            <Skeleton className="h-24 w-full" />
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-8 w-1/2 items-center justify-center z-10 h-full max-md:w-full">
        <div className="flex flex-col gap-3 items-center justify-center">
          <p className="text-[32px] max-md:text-2xl font-medium text-neutralColor text-center">
            {title ? title : t('search.generatingReport.title')}
          </p>
          <p className="text-base max-md:text-sm font-normal text-neutralColor80 text-center">
            {description
              ? description
              : t('search.generatingReport.footerText')}
          </p>
        </div>

        <div className="flex flex-col gap-3 w-full items-center">
          <Progress
            value={progress}
            className="h-4"
            color={SocialMirrorPalette.primary}
            animationDuration={100}
            isLoadingBar
          />
          <p className="text-neutralColor80 font-medium text-base max-md:text-sm text-center">
            {progressText
              ? progressText
              : `${t('search.generatingReport.loading.generic.gathering')}...`}
          </p>
        </div>
      </div>
    </div>
  )
}
